<template>
  <header>
    <div class="header-container">
      <div
        :class="[{'logo active': isPropertiesOpen, 'logo': !isPropertiesOpen}]"
        v-on:click="showPropertyMenu"
      >
        <img :src="property.logo" :alt="property.name" />
      </div>
      <div class="title">
        <h1>
          {{ pageTitle }}
        </h1>
      </div>
      <div class="user">
        <button class="btn" v-on:click="openManageUsers">
          <div class="initials">
            <Avatar :name="name" :size="36" :fontSize="0.8" />
          </div>
          <div class="details">
            <span class="name">{{ name }}</span>
            <span class="manage">Manage Account</span>
          </div>
        </button>
      </div>
    </div>
    <ManageUsers :open="isManageUsersOpen" :close="closeManageUsers" />
  </header>
</template>

<script>
import { mapState } from "vuex";
import Avatar from "./Avatar.vue";
import ManageUsers from "./ManageUsers.vue";

export default {
  name: "Header",
  components: {
    Avatar,
    ManageUsers
  },
  data: function() {
    return {
      isManageUsersOpen: false,
      isPropertiesOpen: false,
      pageTitle: ""
    };
  },
  computed: {
    nowDate: function() {
      let date = new Date();
      return date.toLocaleString("en-US", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric"
      });
    },
    ...mapState("session", {
      name: "name",
      property: "property"
    })
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.pageTitle = to.name;
      }
    }
  },
  methods: {
    showPropertyMenu: function(e) {
      e.preventDefault();
      this.$store.commit("ui/togglePropertyMenu");
      this.isPropertiesOpen = !this.isPropertiesOpen;
    },
    openManageUsers: function() {
      this.isManageUsersOpen = true;
    },
    closeManageUsers: function() {
      this.isManageUsersOpen = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/_variables";

header {
  border-bottom: 1px solid #e9e9e9;
  min-height: 70px;
  display: flex;
  padding-left: 50px;
  padding-right: 50px;
  .header-container {
    display: flex;
    width: 100%;
  }
  h1 {
    font-size: 1.875rem;
    font-weight: 400;
    line-height: 1;
    position: relative;
    top: 6px;
    padding-left: 10%;

    small {
      font-size: 0.875rem;
      font-family: $serifFont;
      display: inline-block;
      margin-left: 1em;
      line-height: 1;
    }
  }

  div.logo {
    flex: 0 0 20%;
    max-width: 20%;
    padding-left: 15px;
    cursor: pointer;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    &::after {
      content: "";
      position: absolute;
      left: 18%;
      top: 32px;
      width: 0;
      height: 0;
      border-left: 6px solid transparent;
      border-right: 6px solid transparent;
      border-top: 6px solid #000;
      clear: both;
      transition: transform 250ms;
    }
    &.active {
      &::after {
        transform: rotate(180deg);
      }
    }
  }

  div.title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    flex-grow: 1;
    width: 100%;
    width: fit-content;
  }

  div.user {
    display: flex;
    justify-content: flex-end;

    button.btn {
      background-color: rgba(var(--accentColorRgb), 0.075);
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: calc(100% + 1px);

      div.details {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;

        span.name {
          font-size: 0.75rem;
          line-height: 1.16;
          color: #4a4a4a;
        }

        span.manage {
          color: rgba(#222222, 0.56);
          font-size: 0.625rem;
          line-height: 1;
        }
      }
    }

    a {
      color: black;
      font-size: 0.8rem;
      padding-right: 15px;
    }
  }
}
</style>
